export default (): string => {
  let guid: number = Math.random() * 36
  return Date.now().toString(36) + (guid++ % 36).toString(36) + Math.random().toString(36).slice(2, 4)
}
